/** Player name clean-up applied as names arrive from the server. */
import { session } from './Session';

/** Strips the server-configured bot name prefix from a player name, if present. */
export function stripBotsNamePrefix(name: string) {
  const botsPrefix = session.serverConfig?.botsNamePrefix;

  if (!botsPrefix) {
    return name;
  }

  if (!name.startsWith(botsPrefix)) {
    return name;
  }

  return name.substring(botsPrefix.length);
}
